import React from "react";
import PropTypes from "prop-types";
import IChangeAddress from "../resources/ChangeAddress.png";
import IChangeDate from "../resources/ChangeDate.png";
import INeighbour from "../resources/Neighbour.png";
import IPickupShop from "../resources/PickupShop.png";
import IPrecise from "../resources/Precise.png";
import ISafePlace from "../resources/SafePlace.png";
import IUpgrade from "../resources/Upgrade.png";
import ICollectFromDepot from "../resources/CollectFromDepot.png";
const iconMap = {
  ONE: IPrecise,
  PKU: IPickupShop,
  ALA: IChangeAddress,
  RED: IChangeDate,
  SFP: ISafePlace,
  DTN: INeighbour,
  UPG: IUpgrade,
  TBC: ICollectFromDepot
};

const SuggestionSquare = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: props.className + " suggestion-square",
    onClick: props.onClick
  }, /*#__PURE__*/React.createElement("img", {
    alt: "Suggestion Description",
    src: iconMap[props.option.icon]
  }), /*#__PURE__*/React.createElement("label", null, props.option.title));
};

SuggestionSquare.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  option: PropTypes.object
};
export default SuggestionSquare;